import TemporaryEcgHackedGraph from './TemporaryEcgHackedGraph'

export default TemporaryEcgHackedGraph



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/TemporaryEcgHackedGraph/index.js